import { render } from "./QuestionsForm.vue?vue&type=template&id=761988e2&scoped=true"
import script from "./QuestionsForm.vue?vue&type=script&lang=js"
export * from "./QuestionsForm.vue?vue&type=script&lang=js"

import "./QuestionsForm.vue?vue&type=style&index=0&id=761988e2&scoped=true&lang=css"
import "./QuestionsForm.vue?vue&type=style&index=1&id=761988e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761988e2"]])

export default __exports__